module.exports = __webpack_public_path__ + "static/media/ponyo-loc.22432eb9.JPG";